import { render, staticRenderFns } from "./SuggestionsPanel.vue?vue&type=template&id=8f0fe4b6&scoped=true"
import script from "./SuggestionsPanel.vue?vue&type=script&lang=js"
export * from "./SuggestionsPanel.vue?vue&type=script&lang=js"
import style0 from "./SuggestionsPanel.vue?vue&type=style&index=0&id=8f0fe4b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0fe4b6",
  null
  
)

export default component.exports